module.exports = __webpack_public_path__ + "img/packages/v6.b309d8.png";